import { useEffect, useState } from "react";

export const useAccountData = () => {
  const [accountData, setAccountData] = useState(null);

  useEffect(() => {
    const loadUser = () => {
      const stored = localStorage.getItem("user");
      if (stored) {
        try {
          const parsed = JSON.parse(stored);
          setAccountData(parsed);
        } catch (err) {
          console.error("Invalid user data in localStorage:", err);
        }
      } else {
        setAccountData(null);
      }
    };

    loadUser();
    window.addEventListener("storage", loadUser);
    return () => window.removeEventListener("storage", loadUser);
  }, []);

  return accountData;
};
